module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h6', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(_vm.meetup.title))])]), _vm._v(" "), _c('v-card-media', {
    attrs: {
      "src": _vm.meetup.imageUrl,
      "height": "400px"
    }
  }), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "info--text"
  }, [_vm._v(_vm._s(_vm.meetup.date) + "g - Where it takes place")]), _vm._v(" "), _c('div', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci assumenda at deserunt dolorum eius esse eum, expedita hic illo ipsum magni, nobis, odio odit quaerat quibusdam quis rem veritatis voluptas!")])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary"
  }, [_vm._v("Register")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e46300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Meetup/Meetup.vue
// module id = 51
// module chunks = 1